import React, { useState, useEffect } from "react";

import Input from "../inputField";
import { InfoArea } from "./styles";
import { StyledRow } from "./styles";
import { dateRegex } from "../../common/regex";
import CustomSelect from "components/selectField";
import { handleCommaFormat, numberWithCommas } from "../../common/numberFormat";
import {
  NumberFormatOnly,
  NumberFormatWithCurrency,
} from "components/locale/numberFormatOnly.js";
import DateTimePickerField from "components/dateTimePickerField";
import { getECQSWizardContextSelector } from "data/selectors/ecqs";
import { useSelector } from "react-redux";

export const Step1 = ({ setDisable, addData, setAddData, isMobile }) => {
  const wizardContext = useSelector(getECQSWizardContextSelector);
  const isESub = wizardContext === "e-sub";

  useEffect(() => {
    if (isESub) {
      setAddData("project_info.project_status", "Awarded");
    }
  }, [isESub, wizardContext]);

  const projectType = isESub
    ? ["Underway", "Completed", "Awarded"]
    : ["Underway", "Completed"];

  const [temporaryStorageOfType, setTemporaryStorageOfType] = useState(isESub ? "Awarded" : "");

  const totalEstimatedCostOfRevenue = parseFloat(
    addData?.estimated_cost_of_revenue
  );
  const cost_incurred_to_date = parseFloat(
    addData?.cost_incurred_to_date
  );


  const percentCompleted =
    totalEstimatedCostOfRevenue > 0 && parseFloat(cost_incurred_to_date) > 0
      ? ((cost_incurred_to_date / totalEstimatedCostOfRevenue) * 100).toFixed(
        0
      )
      : 0;

  const updateData = (field, val) => {
    if (field === "project_name") {
      if (isESub) {
        setAddData("project_info.project_title", val);
      } else {
        setAddData("project_name", val);
      }
    }
    if (field === "project_number") {
      if (isESub) {
        setAddData("project_info.project_number", val);
      } else {
        setAddData("project_number", val);
      }
    }
    if (field === "project_location") {
      if (isESub) {
        setAddData("project_info.project_location", val);
      } else {
        setAddData("project_location", val);
      }
    }
    if (field === "project_status") {
      if (isESub) {
        setAddData("project_info.project_status", val);
      } else {
        setAddData("project_status", val);
      }
    }

    if (field === "value") {
      if (isESub) {
        setAddData("bond_details.contract_price", val);
      } else {
        setAddData("value", val);
      }
    }

    if (field === "planned_start_date") {
      setAddData("project_info.planned_start_date", val);
    }
    if (field === "original_estimated_cost_of_revenue") {
      setAddData("project_info.original_estimated_cost_of_revenue", val);
    }
    if (field === "completed_date") {
      if (isESub) {
        setAddData("project_info.scheduled_completion_date", val);
      } else {
        setAddData("completed_date", val);
      }
    }
  }

  const getData = (field) => {
    if (field === "project_name") {
      if (isESub) {
        return addData?.project_info?.project_title;
      } else {
        return addData?.project_name;
      }
    }
    if (field === "project_number") {
      if (isESub) {
        return addData?.project_info?.project_number;
      } else {
        return addData?.project_number;
      }
    }
    if (field === "project_location") {
      if (isESub) {
        return addData?.project_info?.project_location;
      } else {
        return addData?.project_location;
      }
    }
    if (field === "project_status") {
      if (isESub) {
        return addData?.project_info?.project_status;
      } else {
        return addData?.project_status;
      }
    }
    if (field === "value") {
      if (isESub) {
        return addData?.bond_details?.contract_price;
      } else {
        return addData?.value;
      }
    }
    if (field === "planned_start_date") {
      return addData?.project_info?.planned_start_date;
    }
    if (field === "original_estimated_cost_of_revenue") {
      return addData?.project_info?.original_estimated_cost_of_revenue;
    }
    if (field === "completed_date") {
      if (isESub) {
        return addData?.project_info?.scheduled_completion_date;
      } else {
        return addData?.completed_date;
      }
    }
    return null;
  }

  useEffect(() => {
    if (
      addData?.project_name?.length > 0 &&
      addData?.project_number?.length > 0 &&
      addData?.project_location?.length > 0 &&
      (addData?.completed_date?.length > 0
        ? dateRegex.test(addData?.completed_date)
        : true) &&
      (addData?.substantial_date?.length > 0
        ? dateRegex.test(addData?.substantial_date)
        : true) &&
      (addData?.percent_completed?.length > 0 ? percentCompleted : 0)
    ) {
      setDisable(false);
    } else {
      setDisable(false);
    }
  }, [addData]);
  const [valueCons, setValueCons] = useState(
    addData["value"] ? NumberFormatOnly(addData["value"]) : ""
  );

  const removeComma = (e) => {
    var num = e;
    if (typeof num === "string") {
      var str = num.replaceAll(",", "");
      str = str.replaceAll(".", "");
      num = Number(str);
    }

    if (isNaN(num)) {
      return 0;
    } else {
      return num;
    }
  };

  return (
    <InfoArea
      isMobile={isMobile}
      marginTop="0px"
      marginLeft="8px"
      isColumn={true}
    >
      <CustomSelect
        style={{ paddingRight: "16px" }}
        label="Project Status*"
        options={projectType.map((item) => ({ value: item, label: item }))}
        value={
          getData("project_status") || temporaryStorageOfType
        }
        setValue={(val) => {
          setTemporaryStorageOfType(val);
          updateData("project_status", val);
        }}
        validateFunc={(item) => Boolean(item)}
        noCheckIcon={true}
        showDropdownIndicator={true}
      />
      <StyledRow isMobile={isMobile}>
        <Input
          id="fullWidthInputWrap"
          label="Project Title"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={getData("project_name") || ""}
          setValue={(val) => updateData("project_name", val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        />
      </StyledRow>
      <StyledRow isMobile={isMobile}>
        <Input
          id="oneThirdInputWrap"
          label="Project Number"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={getData("project_number") || ""}
          setValue={(val) => updateData("project_number", val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        />
        <Input
          id="twoThirdInputWrap"
          label="Location"
          type="text"
          placeholder=""
          labelSize="12px"
          fontSize="18px"
          value={getData("project_location") || ""}
          setValue={(val) => updateData("project_location", val)}
          validateFunc={(item) => item.length > 0}
          noCheckIcon={true}
          noErrorBorder={true}
        />
      </StyledRow>
      <StyledRow isMobile={isMobile}>
        {getData("project_status") === "Completed" && (
          <>
            {/* <Input
              id="oneThirdInputWrap"
              label="Date Substantially Completed"
              type="text"
              placeholder="MM/DD/YYYY"
              labelSize="12px"
              fontSize="18px"
              value={addData?.substantial_date || ""}
              setValue={(val) => setAddData("substantial_date", val)}
              validateFunc={(item) => dateRegex.test(item)}
              noCheckIcon={true}
              noErrorBorder={true}
            />
            <Input
              id="oneThirdInputWrap"
              label="Date Completed"
              type="text"
              placeholder="MM/DD/YYYY"
              labelSize="12px"
              fontSize="18px"
              value={addData?.completed_date || ""}
              setValue={(val) => {
                console.log(val);
                setAddData("completed_date", val);
              }}
              validateFunc={(item) => dateRegex.test(item)}
              noCheckIcon={true}
              noErrorBorder={true}
            /> */}

            <DateTimePickerField
              showDateField={true}
              dateWidth="50%"
              paddingRight="16px"
              dateLabel="Date Substantially Completed"
              dateValue={
                addData?.substantial_date ? addData?.substantial_date : ""
              }
              setDateValue={(val) => {
                setAddData("substantial_date", val);
              }}
            />
            <DateTimePickerField
              showDateField={true}
              dateWidth="50%"
              paddingRight="16px"
              dateLabel="Date Completed"
              dateValue={addData?.completed_date ? addData?.completed_date : ""}
              setDateValue={(val) => {
                setAddData("completed_date", val);
              }}
            />
            <Input
              id="oneThirdInputWrap"
              label="Value at Completion"
              type="text"
              placeholder="$"
              labelSize="12px"
              fontSize="18px"
              value={valueCons}
              setValue={(val) => {
                setValueCons(val);
                setAddData("value", val);
              }}
              validateFunc={(item) => item.length > 0}
              onBlur={(e) => setValueCons(NumberFormatOnly(e.target.value))}
              noCheckIcon={true}
              noErrorBorder={true}
            />
          </>
        )}
        {/* addData?.project_info.status === "Awarded" is an eSUB only option */}
        {["Underway", "Awarded"].includes(getData("project_status")) && (
          <>
            {/* <Input
              id="oneThirdInputWrap"
              label="Scheduled Completion Date"
              type="text"
              placeholder="MM/DD/YYYY"
              labelSize="12px"
              fontSize="18px"
              value={addData?.completed_date || ""}
              setValue={(val) => setAddData("completed_date", val)}
              validateFunc={(item) => dateRegex.test(item)}
              noCheckIcon={true}
              noErrorBorder={true}
            /> */}
            <DateTimePickerField
              showDateField={true}
              dateWidth="50%"
              paddingRight="16px"
              dateLabel="Scheduled Completion Date"
              dateValue={getData("completed_date") || ""}
              setDateValue={(val) => {
                updateData("completed_date", val);
              }}
            />
            <Input
              id="oneThirdInputWrap"
              label="Percent Completed"
              type="text"
              placeholder="%"
              labelSize="12px"
              fontSize="18px"
              value={addData?.percent_completed || ""}
              setValue={(val) => setAddData("percent_completed", val)}
              onBlur={(e) => {
                let inputValue = e.target.value.trim();
                if (inputValue !== "") {
                  let parsedValue = parseFloat(inputValue);
                  parsedValue = isNaN(parsedValue) ? 0 : parsedValue;
                  parsedValue = Math.min(100, Math.max(0, parsedValue));
                  inputValue = `${parsedValue}%`;
                }
                setAddData("percent_completed", inputValue);
              }}
              noCheckIcon={true}
              noErrorBorder={true}
              disabled={true}
            />
            <Input
              id="oneThirdInputWrap"
              label="Project Value At Award*"
              type="text"
              placeholder="$"
              labelSize="12px"
              fontSize="18px"
              value={getData("value") ? NumberFormatOnly(getData("value")) : ""}
              setValue={(val) => {
                const formattedValue = NumberFormatOnly(val);
                setValueCons(formattedValue);
                updateData("value", val);
              }}
              validateFunc={(item) => String(item).length > 0}
              noCheckIcon={true}
              noErrorBorder={true}
            />
          </>
        )}
      </StyledRow>
      {isESub && (
        <StyledRow isMobile={isMobile}>
          <DateTimePickerField
            showDateField={true}
            dateWidth="50%"
            paddingRight="8px"
            dateLabel="Planned Start Date"
            dateValue={getData("planned_start_date") || ""}
            setDateValue={(val) => updateData("planned_start_date", val)}
          />
          <Input
            id="oneThirdInputWrap"
            label="Estimated Cost"
            type="text"
            placeholder="$"
            labelSize="12px"
            fontSize="18px"
            value={getData("original_estimated_cost_of_revenue") ? NumberFormatOnly(getData("original_estimated_cost_of_revenue")) : ""}
            setValue={(val) => updateData("original_estimated_cost_of_revenue", val)}
            onBlur={(e) => updateData("original_estimated_cost_of_revenue", NumberFormatOnly(e.target.value))}
            validateFunc={(item) => String(item).length > 0}
            noCheckIcon={true}
            noErrorBorder={true}
            style={{ width: '50%' }}
          />
        </StyledRow>
      )}
    </InfoArea>
  );
};
